import { showErrorNotification } from '@utils';
import { useEffect, useRef } from 'react';
import { Navigate, Outlet } from 'react-router';

export const ProtectedRoute: React.FC<{
  isAllowed: boolean;
  redirectPath?: string;
}> = ({ isAllowed, redirectPath = '/' }) => {
  const hasShownErrorRef = useRef(false);

  useEffect(() => {
    // Show error when:
    // 1. User tries to access protected route without permission (initial mount with isAllowed=false)
    // 2. User loses permission while on the route (changing from true to false)
    if (!isAllowed && !hasShownErrorRef.current) {
      showErrorNotification(new Error('You do not have sufficient permissions to visit that route'));
      hasShownErrorRef.current = true;
    }

    // Reset the error flag when user gains permission
    if (isAllowed && hasShownErrorRef.current) {
      hasShownErrorRef.current = false;
    }
  }, [isAllowed]);

  return isAllowed ? <Outlet /> : <Navigate replace to={redirectPath} />;
};
